import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import { AppSettings } from '@prodcard/core'
import { useWatcherSavedRef } from '../../../helpers'
import useVuelidate, { ErrorObject } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

interface Props {
  settings?: AppSettings
  loading?: boolean
  saving?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSettingsForm',
  props: {
    settings: {},
    loading: { type: Boolean, default: false },
    saving: { type: Boolean }
  },
  emits: ['onSubmit'],
  setup(__props: any, { emit }) {

const props = __props;




const appSettings = useWatcherSavedRef<AppSettings>('AppSettings', {
  serverBaseUrl: props.settings?.serverBaseUrl ?? '',
})

const rules = computed(() => ({
  serverBaseUrl: {
    required: helpers.withMessage('URL не может быть пустым', required),
  },
}))

const validator = useVuelidate<AppSettings>(rules, appSettings)

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) emit('onSubmit', appSettings.value)
}

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join()
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submit, ["prevent"]),
    disabled: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(appSettings).serverBaseUrl,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(appSettings).serverBaseUrl) = $event)),
                "error-messages": getErrorMessages(_unref(validator).serverBaseUrl.$errors),
                label: "URL сервера*"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.saving
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit", "disabled"]))
}
}

})